import axios from "axios";
import { initializeApp } from "firebase/app";
import {
  FacebookAuthProvider,
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";
import OtherInfo from "./OtherInfo";
import OtpModal from "./OtpModal";

// 🔹 Firebase Config
const firebaseConfig = {
  apiKey: "AIzaSyCqpwRYrXtMSkdH_HLgY2eca8FPIb7PVM0",
  authDomain: "weyfarin-a4599.firebaseapp.com",
  projectId: "weyfarin-a4599",
  storageBucket: "weyfarin-a4599.firebasestorage.app",
  messagingSenderId: "1023965737455",
  appId: "1:1023965737455:web:56cbf24d3cb093572e861a",
  measurementId: "G-3PB2YMZME0",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();

function LoginModal({ isOpen, onClose, userType }) {
  const [email, setEmail] = useState("");
  const [otpEmail, setOtpEmail] = useState("");

  const [isOtpOpen, setIsOtpOpen] = useState(false);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(""); // ✅ store country id
  const [countryDialCode, setCountryDialCode] = useState(""); // ✅ store dial code
  const [countryId, setCountryId] = useState("");
  const [showOtherInfoModal, setShowOtherInfoModal] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const navigate = useNavigate();
  const emailRef = useRef(null);
  const countryRef = useRef(null);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/getCountries`,
        );
        if (res.data && res.data.status) {
          setCountries(res.data.data);
        }
      } catch (err) {
        console.error("Error fetching countries:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCountries();
  }, []);

  useEffect(() => {
  const selected = JSON.parse(localStorage.getItem("selectedCurrency"));

  if (selected?.country_name && countries.length > 0) {
    const country = countries.find(
      (c) => c.name === selected.country_name
    );

    if (country) {
      setSelectedCountry(country.id);
      setCountryId(country.id);
      setCountryDialCode(country.dial_code);
    }
  }
}, [countries]);

  if (!isOpen && !isOtpOpen) return null;

  const closeOtherInfo = () => {
    setShowOtherInfoModal(false);
    onClose();
  };

  const handleContinue = async (e) => {
    e.preventDefault();

    const trimmedEmail = email.trim();

    // ✅ Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
    if (!countryId) {
      toast.error("Please select a country");
      countryRef.current?.focus(); // ✅ focus country select
      return;
    }

    if (!trimmedEmail) {
      toast.error("Please enter your email");
      emailRef.current?.focus(); // ✅ focus email input
      return;
    }

    if (!emailRegex.test(trimmedEmail)) {
      toast.error("Please enter a valid email address");
      emailRef.current?.focus();
      return;
    }

    try {
      setLoadingSubmit(true);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/user/register-user`,
        {
          country_id: countryId,
          email: email,
          user_type: userType || 1,
        },
      );

      if (res.data && res.data.status) {
        onClose();
        setOtpEmail(email);
        setIsOtpOpen(true); // ✅ Open OTP Modal
      } else {
        toast.error(res.data.message || "Registration failed");
      }
    } catch (err) {
      console.error("Register error:", err);

      const errMsg =
        err.response?.data?.message ||
        "Something went wrong while Sending OTP.";
      toast.error(errMsg);
    } finally {
      setLoadingSubmit(false);
    }
  };

  const closeOtpModal = () => {
    setIsOtpOpen(false);
  };

  //  Google login
  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      // Split name into first and last
      const [firstName, ...lastNameArr] = user.displayName?.split(" ") || [];
      const lastName = lastNameArr.join(" ") || "";

      // ✅ Call API
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/user/social_register`,
        {
          first_name: firstName,
          last_name: lastName,
          email: user.email,
          social_id: user.uid,
          social_type: "google",
          image: user.photoURL,
          country_id: countryId || 1,
          user_type: userType || 1,
        },
      );

      if (res.data && res.data.status) {
        const userData = res.data.user;

        const wishlist = res.data.wishlist_ids;
        // ✅ Save user data & token

        const expiresIn = 60 * 60 * 1000;
        const expiryTime = Date.now() + expiresIn;

        localStorage.setItem("user", JSON.stringify(userData));
        localStorage.setItem("authToken", res.data.token);
        localStorage.setItem("loginTime", Date.now().toString());
        localStorage.setItem("expiry", expiryTime.toString());
        localStorage.setItem("userWishlist", JSON.stringify(wishlist));

        setUserDetails(userData);

        if (res.data.user?.signup_complete_status === "0") {
          // ✅ Open OtherInfo modal only
          setShowOtherInfoModal(true);
        } else {
          // ✅ Redirect to profile page and close modal
          onClose();

          const pendingHid = localStorage.getItem("pendingHid");
          const pendingEid = localStorage.getItem("pendingEid");

          if (pendingHid && pendingEid) {
            toast.success("Login successful");
            localStorage.removeItem("pendingHid");
            localStorage.removeItem("pendingEid");
            onClose(); // 🔹 Close OTP modal directly
            return;
          }

          // if (userType === 2) {
          //   window.location.href = "/listing";
          // } else {
          //   window.location.href = "/profile";
          // }

          if (
            res.data.user.user_type === 2 &&
            res.data.user.host_profile === 1
          ) {
            navigate("/listing");
          } else if (
            res.data.user.user_type === 2 &&
            res.data.user.host_profile === 0
          ) {
            navigate("/host-category");
          } else {
            navigate("/profile");
          }
        }
      } else {
        toast.error(res.data.message || "Google login failed");
      }
    } catch (error) {
      console.error("Google login error:", error);
      toast.error("Google login failed");
    }
  };

  // Facebook login
  const handleFacebookLogin = async () => {
    try {
      const result = await signInWithPopup(auth, facebookProvider);
      const user = result.user;

      // Split name into first and last
      const [firstName, ...lastNameArr] = user.displayName?.split(" ") || [];
      const lastName = lastNameArr.join(" ") || "";

      // Call API
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/user/social_register`,
        {
          first_name: firstName,
          last_name: lastName,
          email: user.email,
          social_id: user.uid,
          social_type: "facebook",
          image: user.photoURL,
          country_id: countryId || 1,
          user_type: 1,
        },
      );

      if (res.data && res.data.status) {
        const userData = res.data.user;

        //  Save user data & token
        localStorage.setItem("user", JSON.stringify(userData));
        localStorage.setItem("authToken", res.data.token);
        setUserDetails(userData);

        if (res.data.signup_complete_status === 0) {
          // ✅ Open OtherInfo modal only
          setShowOtherInfoModal(true);
        } else {
          //  Redirect to profile page and close modal
          onClose();
          window.location.href = "/profile";
        }
      } else {
        toast.error(res.data.message || "Facebook login failed");
      }
    } catch (error) {
      console.error("Facebook login error:", error);
      toast.error("Facebook login failed");
    }
  };

  return (
    <>
      {isOpen && (
        <div
          className="modal fade all_modalss show"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content detailspgess">
              <div className="modal-header">
                <button type="button" className="close" onClick={onClose}>
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div className="shedow_booox">
                  <div className="al_titlss_ara">
                    <h3>Login or Sign up</h3>
                    <p className="discrpss">Welcome to Weyfarin Experiences</p>
                  </div>

                  {/* Phone login */}
                  <form onSubmit={handleContinue}>
                    <div className="form-group">
                      <label>Country / Region</label>

                      <select
                        className="form-control"
                        ref={countryRef}
                        value={selectedCountry}
                        onChange={(e) => {
                          const selected = countries.find(
                            (c) => c.id === e.target.value,
                          );
                          setSelectedCountry(e.target.value);
                          setCountryId(e.target.value); // ✅ API ke liye countryId set
                          setCountryDialCode(selected?.dial_code || "");
                        }}
                      >
                        {loading ? (
                          <option>Loading countries...</option>
                        ) : (
                          <>
                            <option value="">Select Country</option>
                            {countries.map((country) => (
                              <option key={country.id} value={country.id}>
                                {country.name} {country.dial_code}
                              </option>
                            ))}
                          </>
                        )}
                      </select>
                    </div>

                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="email"
                        ref={emailRef}
                        className="form-control"
                        value={email} /* state name email */
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>

                    <div className="form-group">
                      <div className="submmit">
                        {/* <button type="submit">Continue</button> */}
                        <button type="submit" disabled={loadingSubmit}>
                          {loadingSubmit ? "Submitting..." : "Continue"}
                        </button>
                      </div>
                    </div>
                  </form>

                  <div className="or">
                    <span className="OR">Or</span>
                  </div>

                  {/* Google & Facebook buttons */}
                  <div className="user_logins">
                    <ul>
                      <li>
                        <a onClick={handleGoogleLogin}>
                          Continue with Google{" "}
                          <img src="/images/google_ic.png" alt="Google" />
                        </a>
                      </li>
                      {/* <li>
                        <a onClick={handleFacebookLogin}>
                          Continue with Facebook{" "}
                          <img src="/images/facebook_ic.png" alt="Facebook" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          Continue with Email{" "}
                          <img src="/images/envelope_ic.png" alt="Email" />
                        </a>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* overlay */}
          <div className="modal-backdrop fade show" onClick={onClose}></div>
        </div>
      )}

      {isOtpOpen && (
        <OtpModal
          isOpen={isOtpOpen}
          onClose={closeOtpModal}
          email={otpEmail}
          userType={userType}
        />
      )}

      {showOtherInfoModal && (
        <OtherInfo
          isOpen={showOtherInfoModal}
          // onClose={() => setShowOtherInfoModal(false)}
          onClose={closeOtherInfo}
          user={userDetails}
          userType={userType}
        />
      )}
    </>
  );
}

export default LoginModal;
